import {Link, useLocation, useParams} from "react-router-dom";
import {useMachine} from "@xstate/react";
import {distrStatMachine} from "../../xstate/distributor.machine";
import {Loader} from "../Loader/Loader";
import {ChartArea} from "../ChartArea/ChartArea";
import styles from "./DistributorStat.module.scss";
import {ChartSelect} from "../ChartSelect/ChartSelect";
import {periodsList} from "../../constants";
import {useEffect} from "react";
import clsx from "clsx";
import {NoData} from "../NoData/NoData";
import {Pagination} from "../Pagination/Pagination";

export function DistributorStat() {

    let {distributorID = ""} = useParams();

    let [stateDistr, sendDistr] = useMachine(distrStatMachine, {
        context: {
            ...distrStatMachine.context,
            id: distributorID.replace(/distr/g, "")
        }
    });

    return (
        <>
            <h1>Статистика торговых точек</h1>

            {
                stateDistr.context.errorMsg.length > 0 &&
                stateDistr.context.errorMsg.map((item, index)=>{
                    return <div className="errorMessage" key={index}>
                        {item}
                    </div>
                })
            }

            <section className={clsx("statContainer", styles.chartArea)}>
                <div className={styles.titleBlock}>
                    <h2>График продаж</h2>

                    <div className={styles.chartControls}>
                        <ChartSelect
                            send={sendDistr}
                            type={"CHANGE_FILTER"}
                            dataName={"shop"}
                            label={"Торговая точка: "}
                            name={"shop"}
                            default={stateDistr.context.current_shop.toString()}
                            options={stateDistr.context.shops}
                        />
                        <ChartSelect
                            send={sendDistr}
                            type={"CHANGE_FILTER"}
                            dataName={"period"}
                            label={"Выбор периода"}
                            name={"periodSelect"}
                            defaultValue={"week"}
                            options={[...periodsList]}
                        />
                    </div>
                </div>
                {
                    stateDistr.matches({chart: "loading"})
                        ? <Loader/>
                        : <ChartArea
                            chart_data={stateDistr.context.chart_data}
                        />
                }
            </section>

            <section className={"statContainer"}>
                <h2 className="visuallyHidden">Таблица продаж</h2>

                {
                    stateDistr.context.list.length > 0
                        ? <>
                            <ShopsTable
                                data={stateDistr.context.list}
                            />
                            {
                                stateDistr.context.pages > 1 &&
                                <Pagination
                                    pages={stateDistr.context.pages}
                                    current_page={stateDistr.context.current_page}
                                    send={sendDistr}
                                />
                            }
                        </>
                        : <NoData/>
                }
            </section>
        </>
    )
}

function ShopsTable(props) {
    if (props.data.length === 0) {
        return <NoData/>
    } else {
        return <div className="scrollbox">
            <table id={"distrTable"} className={"statTable"}>
                <thead>
                <tr>
                    <th>Торговые точки</th>
                    <th>Регион</th>
                    <th>Кол-во продавцов</th>
                    <th>Продано ед.</th>
                    <th>Сумма продаж</th>
                    <th>Кол-во исп. баллов</th>
                </tr>
                </thead>
                <tbody>
                {
                    props.data.map(item => {
                        return <tr key={item.id}>
                            <td className={styles.itemName}>
                                <Link to={`shop${item.id}`}>
                                    {item.name}
                                </Link>
                            </td>
                            <td className={"noWhiteSpace"}>
                                {item.address}
                            </td>
                            <td>
                                {item.sellers}
                            </td>
                            <td>
                                {new Intl.NumberFormat('ru-RU').format(item.volume)} ед.
                            </td>
                            <td className={"noWhiteSpace"}>
                                {new Intl.NumberFormat('ru-RU').format(item.sum)} &#8381;
                            </td>
                            <td className={"noWhiteSpace"}>
                                {new Intl.NumberFormat('ru-RU').format(item.points)} баллов
                            </td>
                        </tr>
                    })
                }
                </tbody>
            </table>
        </div>
    }
}